import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Typography,
  useMediaQuery,
} from "@mui/material";
import * as React from "react";
import CustomDataGrid from "../../../CustomComponents/CustomDataGrid";
import CustomTextField from "../../../CustomComponents/CustomTextField";
import NoDataFound from "../../../CustomComponents/NoDataFound";

const FeeOutstandingAndDeductionsTab = (props) => {
  const editMode =
    props.screenMode === "CREATE" || props.screenMode === "MODIFY";
  const feeDeductionColumns = [
    {
      field: "details",
      headerName: "Fee Details",
      headerAlign: "center",
      type: "string",
      hideable: false,
      sortable: false,
      flex: 350,
      align: "left",
    },
    {
      field: "receiveable",
      headerName: "Due Amount (₹)",
      headerAlign: "center",
      type: "string",
      flex: editMode ? 188 : 235,
      align: "right",
      editable: false,
      renderCell: (params) => {
        return <>{parseInt(params.value).toLocaleString("en-IN")}</>;
      },
    },
    {
      field: "received",
      headerName: "Paid Amount (₹)",
      headerAlign: "center",
      type: "string",
      flex: editMode ? 188 : 235,
      align: "right",
      editable: false,
      renderCell: (params) => {
        return <>{parseInt(params.value).toLocaleString("en-IN")}</>;
      },
    },
    {
      field: "earlyWaiver",
      headerName: "Waived Amount (₹)",
      headerAlign: "center",
      type: "string",
      flex: editMode ? 188 : 235,
      align: "right",
      editable: false,
      renderCell: (params) => {
        return <>{parseInt(params.value).toLocaleString("en-IN")}</>;
      },
    },
    {
      field: "deduction",
      headerName: "Deduction (₹)",
      headerAlign: "center",
      type: "string",
      flex: editMode ? 188 : 235,
      editable: false,
      align: "right",
      renderCell: (params) => {
        var value =
          params.row.receiveable - params.row.received - params.row.earlyWaiver;
        return <>{parseInt(value).toLocaleString("en-IN")}</>;
      },
    },
    // {
    //   field: "additionalAccrual",
    //   headerName: "Additional Accrual",
    //   headerAlign: "center",
    //   type: "string",
    //   flex: 200,
    //   editable: false,
    //   align: "right",
    //   hide: !editMode,
    //   renderCell: (params) => {
    //     return (
    //       <CustomTextField
    //         align="right"
    //         disabled={
    //           !editMode ||
    //           !params.row.details.toUpperCase().includes("INSURANCE", 0)
    //         }
    //         required={false}
    //         label={""}
    //         id="amount"
    //         variant="standard"
    //         value={
    //           params.value === ""
    //             ? 0
    //             : parseInt(params.value).toLocaleString("en-IN")
    //         }
    //         type="text"
    //         placeholder={""}
    //         onChange={onAccuralValueChange(params.row.details)}
    //       />
    //     );
    //   },
    // },
  ];

  const onAccuralValueChange = (description) => (event) => {
    let tempValue = { ...props.historyData };
    const dataMap1 = [];
    let accrualTotal1 = 0;
    props.deductionTabValue.gridRows.forEach((value) => {
      const dataMap = {
        ...value,
      };
      if (value.details === description) {
        dataMap.additionalAccrual = event.target.value.replaceAll(",", "");
        tempValue[value.details] = event.target.value.replaceAll(",", "");
      }
      accrualTotal1 = accrualTotal1 + Number(dataMap.additionalAccrual);
      dataMap1.push(dataMap);
    });
    const dataMap2 = { ...props.deductionTabValue };
    dataMap2.gridRows = dataMap1;
    dataMap2.accrualTotal = accrualTotal1;
    dataMap2.deductionTotal =
      dataMap2.dueTotal +
      dataMap2.accrualTotal -
      (dataMap2.paidTotal - dataMap2.waivedTotal);
    props.dispatchEvent({
      type: "totalDeductionAmt",
      value: dataMap2.deductionTotal,
    });
    props.dispatchEvent({
      type: "totalDisbAmt",
      value: props.disbursementDetailTabValue.disbAmt - dataMap2.deductionTotal,
    });
    props.setHistorydata(tempValue);
    props.setdeductionTabValue(dataMap2);
  };

  const loadCardView = (rows) => {
    return (
      <React.Fragment>
        <Grid container>
          <Box
            sx={{
              height: props.accordianOpenState
                ? window.innerHeight - 650
                : window.innerHeight - 250,
              overflow: "auto",
              flex: "1 auto",
            }}
          >
            {rows.map((row, index) => (
              <React.Fragment>
                <Grid container direction="column" sx={{ flex: "1 auto" }}>
                  <Card>
                    <CardHeader
                      subheader={row.details + " :"}
                      subheaderTypographyProps={{
                        color: "#004A92",
                        fontWeight: "700",
                      }}
                      sx={{
                        textAlign: "left",
                        padding: "16px 16px 0px 16px !important",
                      }}
                    />
                    <CardContent sx={{}}>
                      <Grid
                        container
                        item
                        direction="column"
                        alignItems="flex-start"
                        justifyContent="flex-start"
                      >
                        <Typography padding="1px">
                          {"Paid Amount (₹) : " +
                            parseInt(row.received).toLocaleString("en-IN")}
                        </Typography>
                        <Typography padding="1px">
                          {"Due Amount (₹) : " +
                            parseInt(row.receiveable).toLocaleString("en-IN")}
                        </Typography>
                        <Typography padding="1px">
                          {"Waived Amount (₹) :  " +
                            parseInt(row.earlyWaiver).toLocaleString("en-IN")}
                        </Typography>
                        <Typography padding="1px">
                          {"Deduction (₹) : " +
                            parseInt(
                              row.receiveable - row.received - row.earlyWaiver
                            ).toLocaleString("en-IN")}
                        </Typography>
                        <CustomTextField
                          align="right"
                          disabled={
                            !editMode ||
                            !row.details.toUpperCase().includes("INSURANCE", 0)
                          }
                          required={false}
                          label={""}
                          id="amount"
                          variant="standard"
                          value={
                            row.additionalAccrual === ""
                              ? 0
                              : parseInt(row.additionalAccrual).toLocaleString(
                                  "en-IN"
                                )
                          }
                          type="text"
                          placeholder={""}
                          onChange={onAccuralValueChange(row.details)}
                        />
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
                <Divider />
              </React.Fragment>
            ))}
            {rows.length === 0 && (
              <NoDataFound
                message="No Pending Fee Dues."
                imageStyle={{
                  marginTop:
                    props.accordianOpenState && window.innerHeight < 1000
                      ? "20px"
                      : "20%",
                }}
              />
            )}
          </Box>
        </Grid>
      </React.Fragment>
    );
  };

  return (
    <>
      <Grid container spacing={0}>
        <Grid item xs={12} sm={5} md={4} lg={2.2} xl={3}>
          <label
            style={{
              fontWeight: "bold",
              marginLeft: "8px",
              color: "#2F7DC4",
            }}
          >
            {"Total Deductions (₹) : "}
            <span style={{ color: "#2F7DC4" }}>
              {Object.keys(props.deductionTabValue).length > 0
                ? parseInt(
                    props.deductionTabValue.deductionTotal
                  ).toLocaleString("en-IN")
                : 0}
            </span>
          </label>
        </Grid>
        <Grid
          sx={{ marginLeft: "80px" }}
          item
          xs={12}
          sm={5}
          md={4}
          lg={2.2}
          xl={3}
        >
          <label
            style={{
              fontWeight: "bold",
              marginLeft: "8px",
              color: "#2F7DC4",
            }}
          >
            {"Paid (₹) : "}
            <span style={{ color: "#2F7DC4" }}>
              {Object.keys(props.deductionTabValue).length > 0
                ? parseInt(props.deductionTabValue.paidTotal).toLocaleString(
                    "en-IN"
                  )
                : 0}
            </span>
            {``}
          </label>
        </Grid>
        <Grid item xs={12} sm={5} md={4} lg={2.2} xl={3}>
          <label
            style={{
              fontWeight: "bold",
              marginLeft: "8px",
              color: "#2F7DC4",
            }}
          >
            {"Due (₹) : "}
            <span style={{ color: "#2F7DC4" }}>
              {Object.keys(props.deductionTabValue).length > 0
                ? parseInt(props.deductionTabValue.dueTotal).toLocaleString(
                    "en-IN"
                  )
                : 0}
            </span>
            {``}
          </label>
        </Grid>
        <Grid item xs={12} sm={5} md={4} lg={2.2} xl={3}>
          <label
            style={{
              fontWeight: "bold",
              marginLeft: "8px",
              color: "#2F7DC4",
            }}
          >
            {"Waived (₹) : "}
            <span style={{ color: "#2F7DC4" }}>
              {Object.keys(props.deductionTabValue).length > 0
                ? parseInt(props.deductionTabValue.waivedTotal).toLocaleString(
                    "en-IN"
                  )
                : 0}
            </span>
            {``}
          </label>
        </Grid>
        <Grid item xs={12} sm={5} md={4} lg={2.2} xl={3}>
          <label
            style={{
              fontWeight: "bold",
              marginLeft: "8px",
              color: "#2F7DC4",
            }}
          >
            {"Deduction (₹) : "}
            <span style={{ color: "#2F7DC4" }}>
              {Object.keys(props.deductionTabValue).length > 0
                ? parseInt(
                    props.deductionTabValue.deductionTotal
                  ).toLocaleString("en-IN")
                : 0}
            </span>
            {``}
          </label>
        </Grid>
        {/* {editMode ? (
          <Grid item xs={12} sm={6} md={4} lg={2} xl={3}>
            <label
              style={{
                fontWeight: "bold",
                marginLeft: "8px",
                color: "#2F7DC4",
              }}
            >
              {"Additional Accrual : "}
              <span style={{ color: "#2F7DC4" }}>
                {parseInt(props.deductionTabValue.accrualTotal).toLocaleString(
                  "en-IN"
                )}
              </span>
              {``}
            </label>
          </Grid>
        ) : null} */}
      </Grid>

      {useMediaQuery("(min-width:1200px)") && (
        <CustomDataGrid
          noDataMessage="No Outstanding Dues."
          noDataOnFilterMessage="No Outstanding Dues on Applied Filter."
          rows={
            props.deductionTabValue.gridRows
              ? props.deductionTabValue.gridRows
              : []
          }
          loading={
            props.deductionTabValue.gridRows
              ? props.deductionTabValue.gridRows.length === 0
              : true
          }
          columns={feeDeductionColumns}
          rowHeight={40}
          pageSize={10}
          pageSizeOptions={[10]}
          gridLazyLoad={() => {}}
          onSortModelChange={() => {}}
        />
      )}
      {useMediaQuery("(max-width:1200px)") &&
        loadCardView(
          props.deductionTabValue.gridRows
            ? props.deductionTabValue.gridRows
            : []
        )}
    </>
  );
};

export default FeeOutstandingAndDeductionsTab;
